import { useEffect } from "react";
import { useNavigate } from "react-router";

import { ApiUsersTable } from "@api-users/part-1-api-user/components/table/ApiUsersTable";

import { useUserContext } from "@hooks/useUserContext";

export const RenderApiUsersTab = () => {
  const navigate = useNavigate();
  const { user: currentUser } = useUserContext();

  useEffect(() => {
    if (currentUser.isOrgUser) {
      navigate("/organization");
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser.isOrgUser]);

  if (currentUser.isAdministrator) {
    return <ApiUsersTable />;
  }
};
